import { Injectable } from '@angular/core';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { Store } from '@ngrx/store';
import { debugFlagActions, DebugFlagsService } from '@content-platform/web-angular-shared-util-development';
import { DebugFlagsDialogComponent } from '../debug-flags-dialog/debug-flags-dialog.component';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "@angular/material/legacy-dialog";
import * as i3 from "@content-platform/web-angular-shared-util-development";
export class DebugFlagsDialogService {
    constructor(store, dialog, debugFlagsService) {
        this.store = store;
        this.dialog = dialog;
        this.debugFlagsService = debugFlagsService;
    }
    showDebugFlagsModal() {
        const dialogRef = this.dialog.open(DebugFlagsDialogComponent, {
            width: '400px',
            data: { flags: this.debugFlagsService.flags, settings: this.debugFlagsService.settings },
            disableClose: true,
            panelClass: 'debug-flag'
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.store.dispatch(new debugFlagActions.Set(result));
            }
        });
    }
    static { this.ɵfac = function DebugFlagsDialogService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || DebugFlagsDialogService)(i0.ɵɵinject(i1.Store), i0.ɵɵinject(i2.MatLegacyDialog), i0.ɵɵinject(i3.DebugFlagsService)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: DebugFlagsDialogService, factory: DebugFlagsDialogService.ɵfac }); }
}
//# sourceMappingURL=debug-flags-dialog.service.js.map